module.exports = __webpack_public_path__ + "img/Step3.72027b9.svg";